import React, { useEffect, useId } from 'react';

const CloseIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" aria-hidden="true">
        <path d="M6 6l12 12M18 6L6 18" />
    </svg>
);

/**
 * Bottom sheet on mobile and tablet, centred modal dialog on desktop.
 * The shell is identical in both cases; only CSS moves it.
 *
 * `popupClassName` keeps the historical `.substitution-popup` /
 * `.tactic-popup` hooks so nothing outside this component has to care that the
 * popups became sheets.
 */
function MatchSheet({ isOpen, onClose, title, meta, popupClassName, children, footer }) {
    const titleId = useId();

    useEffect(() => {
        if (!isOpen || typeof document === 'undefined') return undefined;

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <>
            <div className="mx-backdrop" aria-hidden="true" onClick={onClose} />
            <div
                className={`mx-sheet${popupClassName ? ` ${popupClassName}` : ''} active`}
                role="dialog"
                aria-modal="true"
                aria-labelledby={titleId}
            >
                <div className="mx-sheet__head">
                    <h4 className="mx-sheet__title" id={titleId}>{title}</h4>
                    {meta && <span className="mx-sheet__meta">{meta}</span>}
                    <button type="button" className="mx-sheet__close" onClick={onClose} aria-label="Close">
                        <CloseIcon />
                    </button>
                </div>
                <div className="mx-sheet__body">{children}</div>
                {footer && <div className="mx-sheet__foot">{footer}</div>}
            </div>
        </>
    );
}

export default MatchSheet;
